import { render, staticRenderFns } from "./cpx_kol_selected.vue?vue&type=template&id=6ebfb16e&scoped=true"
import script from "./cpx_kol_selected.vue?vue&type=script&lang=js"
export * from "./cpx_kol_selected.vue?vue&type=script&lang=js"
import style0 from "./cpx_kol_selected.vue?vue&type=style&index=0&id=6ebfb16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfb16e",
  null
  
)

export default component.exports